import {addOrderToBasket} from "../../../services/api/mergerApi"

export default async function (barcode, fac = 'MCVN') {
    try {
        const {data: response} = await addOrderToBasket(barcode, fac)

        const {success, data, error} = response

        if (!success) {
            throw new Error(error)
        }

        return data
    } catch (e) {
        throw new Error(e)
    }
}
